import React, { useEffect } from 'react';
import { Row, Col, Form, Image, Button } from 'react-bootstrap';
import { $detail, $form, $view, $user } from 'signals/global.signals';
import { handleConfettiComplete, handleEmailChange, handleSubmitEmail } from 'components/views/PublicRoom/_components/PublicRoomLander/_helpers/publicRoomLander.events';
import Confetti from 'components/global/Confetti/Confetti';
import LoaderSpinner from 'components/global/LoaderSpinner';
import { useParams } from 'react-router-dom';
import DefaultAvatar from 'components/global/DefaultAvatar';
import Loadable from 'components/global/Loadable';
import { signOut } from 'utils/auth';

const PublicRoomLander = () => {
  const { id } = useParams();
  useEffect(() => {
    $view.update({
      isConfettiVisible: false,
      isMenuVisible: false,
      isEmailFormVisible: !$user.value?.id,
      isQuickAccessVisible: !!$user.value.id,
    });
  }, [$detail.value.dealExistsInPipeline, $user.value]);
  return (
    <Row className="g-0 h-100">
      <Col lg={12} className="position-absolute top-0 start-0 w-100">
        <Row className="justify-content-end g-0">
          <Col lg="6">
            <div className="d-flex justify-content-end align-items-end p-16 border-bottom border-light border-opacity-25">
              <div className="text-center">
                <Image
                  src="/images/logo-light.svg"
                  alt="DealSend Logo"
                  style={{ height: '70px' }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col lg={6} className="order-lg-0 order-1">
        <div className="w-100 d-flex flex-column justify-content-center align-items-center h-100 bg-dark px-16">
          <div
            className="rounded-circle mb-32"
            style={{ height: '10rem', width: '10rem', overflow: 'hidden' }}
          >
            {$detail.value.logo
              ? <Image src={$detail.value.logo} className="w-100 h-100" style={{ objectFit: 'cover' }} />
              : <DefaultAvatar name={$detail.value.companyName} styleArr={$detail.value.logoColors} fontSize="2.5rem" />}
          </div>
          <div className="text-center">
            <h1 className="fw-700 text-gradient-secondary-primary mb-0">{$detail.value.companyName}</h1>
          </div>
          <div className="mb-32 mt-32" style={{ maxWidth: '600px' }}>
            <h6 className="fs-4 fw-700 text-white">Company Overview:</h6>
            <p className="fs-5 text-white">
              {$detail.value?.overview || 'Dealsharing made simple for investors and founders. Centralized, compliant...'}
            </p>
          </div>
        </div>
      </Col>
      <Col lg={6} className="order-lg-1 order-0">
        <div
          className="d-flex flex-column h-100 justify-content-center px-16 pt-lg-0 pt-120"
          style={{
            background: 'linear-gradient(135deg, #b57edc 0%, #8236cb 100%)',
          }}
        >
          {$view.value.isConfettiVisible && (
            <div className="d-flex flex-column align-items-center text-white">
              <p className="fs-5 text-white">Thank you! ...Loading menu</p>
              <LoaderSpinner className="text-white" />
              <Confetti onComplete={handleConfettiComplete} duration={1500} />
            </div>
          )}
          {$view.value.isEmailFormVisible && (
            <Form className="w-100 mt-32 mx-auto px-16" style={{ maxWidth: '600px' }}>
              <Form.Group className="mb-24">
                <Form.Label className="fs-5 text-white">Enter your email to view the Deal Room:</Form.Label>
                <Form.Control
                  type="email"
                  value={$form.value.email}
                  onChange={handleEmailChange}
                  placeholder="Email Address"
                  className="py-8 bg-transparent border-0 border-bottom border-light rounded-0"
                />
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button variant="outline-light" onClick={() => handleSubmitEmail(id)}>Submit</Button>
              </div>
            </Form>
          )}
          {$view.value.isQuickAccessVisible && (
            <Loadable signal={$detail}>
              <div className="text-center">
                <div className="fs-5 text-white mb-16">Viewing Deal as <span className="fw-700">{`${$user.value.email}`}</span></div>
                <Button variant="outline-light mb-16 px-32" onClick={() => handleSubmitEmail(id)}>View Deal</Button>
                <div>
                  <Button
                    variant="link"
                    size="sm"
                    className="text-white text-decoration-underline p-0"
                    onClick={() => {
                      $user.value = {};
                      signOut();
                    }}
                  >
                    Change User
                  </Button>
                </div>
              </div>
            </Loadable>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default PublicRoomLander;
